// Dependencies
import {
  PRECIOS_CLIENTE_REQ,
  PRECIOS_CLIENTE_REQ_ERROR,
  PRECIOS_CLIENTE_ADD_TAB,
  PRECIOS_CLIENTE_REMOVE_TAB,
  PRECIOS_CLIENTE_HANDLE_SEARCH,
} from "./types";
import { filterArrayByString } from "../../../../lib/utils";

const initialState = {
  loading: false,
  error: false,
  data: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PRECIOS_CLIENTE_REQ:
      return { ...state, loading: true };
    case PRECIOS_CLIENTE_REQ_ERROR:
      return { ...state, loading: false, error: action.error };
    case PRECIOS_CLIENTE_ADD_TAB:
      return {
        ...state,
        loading: false,
        data: [
          ...state.data,
          formattedData(action.payload.data, action.payload.keyTab),
        ],
      };
    case PRECIOS_CLIENTE_REMOVE_TAB:
      return {
        ...state,
        data: state.data.filter(({ key }) => key !== action.payload.keyTab),
      };
    case PRECIOS_CLIENTE_HANDLE_SEARCH:
      const { searchValue, keyTab } = action.payload;
      return {
        ...state,
        data: state.data.map((item) => {
          return item.key === keyTab
            ? {
                ...item,
                searchValue,
                displayedData: filterByFields(searchValue, item.data["data"]),
              }
            : item;
        }),
      };
    default:
      return state;
  }
};

const filterByFields = (searchValue, data) => {
  const filteredFields = [
    "codArticulo_A3",
    "descArticulo",
    "codFamilia",
    "descFamilia",
    "precioFijo",
    "tipoPrecio",
  ];
  return filterArrayByString(data, searchValue, filteredFields);
};

const formattedData = (data, keyTab) => {
  return {
    key: keyTab.toString(),
    searchValue: "",
    title: `${data.codCliente_A3} - ${data.nomFiscalCliente}`,
    codCliente_A3: data.codCliente_A3,
    nomFiscalCliente: data.nomFiscalCliente,
    nomComercialCliente: data.nomComercialCliente,
    codTarifa: data.codTarifa,
    descTarifa: data.descTarifa,
    data: data["preciosCliente"],
    displayedData: data["preciosCliente"]["data"],
  };
};

export default reducer;
